module.exports = __webpack_public_path__ + "static/media/3.03f3e81f.png";